import type { PocInputValidity } from 'commons/types';
import { SearchableDropdown } from 'commons/components';
import {
    NestedSelectableOptions,
    SelectableOptions,
} from 'commons/components/searchable-dropdown/searchable-dropdown.type';
import { MAX_OPTIONS_WITHOUT_SEARCH } from 'core/constants/constants';
import React from 'react';
import { findParentsAndChildrenByKey } from 'modules/settings/pods/settings-automation-rules/constants/functions';
import { ActionOptionsContainer } from 'modules/settings/pods/settings-automation-rules/styled/automation-rules.style';
import { BaseProps } from '../field-conditional.type';

export interface MultipleSelectFieldProps extends BaseProps {
    name: string;
    placeholder?: string;
    options?: SelectableOptions[] | NestedSelectableOptions[];
    defaultSelectedOptions?: { locationId: string }[];
    type?: string;
    virtualized?: boolean;
}

const defaultValidation: PocInputValidity = {
    state: 'valid',
};

const valueMissingValidation: PocInputValidity = {
    state: 'error',
    type: ['value-missing'],
};

export const MultipleSelectField: React.FC<MultipleSelectFieldProps> = (props) => {
    const { name, placeholder, defaultSelectedOptions, options, type, onChange, virtualized } = props;

    const mappedDefaultSelectedOptions = defaultSelectedOptions?.map((el) => el.locationId);
    const [internalState, setInternalState] = React.useState(mappedDefaultSelectedOptions || []);
    const [validity, setValidity] = React.useState(structuredClone(defaultValidation));

    const onMultipleSelectChange = (optionIds: string[]) => {
        const result = findParentsAndChildrenByKey(options, optionIds, 'id');
        if (result) {
            const newValue = result.map((el) => ({
                locationId: el.childValue,
                pocOperationsId: el.parentValue,
            }));
            onChange({ key: name, value: { locations: newValue }, type: type ?? '' });
            setValidity(defaultValidation);
        }
    };

    const onClearHandler = () => {
        onChange({ key: name, value: undefined, type: type ?? '' });
        setValidity(valueMissingValidation);
    };

    return (
        <ActionOptionsContainer>
            <SearchableDropdown
                size="small"
                name={name}
                searchable={(options?.length ?? 0) > MAX_OPTIONS_WITHOUT_SEARCH}
                placeholder={placeholder ?? ''}
                value={internalState}
                options={options || []}
                onValueChange={setInternalState}
                onApplySelection={onMultipleSelectChange}
                validity={validity}
                onClear={onClearHandler}
                floatingAssistiveText
                virtualized={virtualized}
            />
        </ActionOptionsContainer>
    );
};
